import React from "react";
import { mediaSrc } from "../lib/media";
import { Trophy, X } from "lucide-react";
import client from "../lib/api";
import { toast } from "sonner";
import { useLang } from "../i18n/LangContext";

export const TopFive = ({ items, priceLabel, onOpen, onChanged }) => {
  const { t } = useLang();
  const ranked = items.filter((p) => p.rank > 0 && p.disposition !== "disqualified").sort((a, b) => a.rank - b.rank);
  const unrank = async (e, p) => {
    e.stopPropagation();
    try { const r = await client.post(`/properties/${p.id}/rank`, { rank: 0 }); onChanged(r.data); toast.success("Removed from top 5"); }
    catch (err) { toast.error("Couldn't update"); }
  };
  return (
    <section data-testid="top-five" className="rounded-2xl border border-amber-400/20 bg-gradient-to-r from-amber-400/[0.07] via-transparent to-transparent p-4">
      <div className="mb-3 flex items-center justify-between">
        <h3 className="flex items-center gap-2 font-display text-base font-semibold text-white"><Trophy className="h-4 w-4 text-amber-400" /> {t("Top 5 right now")}</h3>
        <p className="text-xs text-muted-foreground">{ranked.length ? `${ranked.length} / 5` : t("Open a property and pick a rank (#1–#5) to shortlist it here")}</p>
      </div>
      {ranked.length > 0 && (
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-5">
          {[1, 2, 3, 4, 5].map((n) => {
            const p = ranked.find((x) => x.rank === n);
            if (!p) return <div key={n} data-testid={`top-slot-${n}`} className="grid h-24 place-items-center rounded-xl border border-dashed border-white/10 text-xs text-muted-foreground">#{n} · empty</div>;
            return (
              <button key={p.id} data-testid={`top-slot-${n}`} onClick={() => onOpen(p.id)} className="group relative flex h-24 overflow-hidden rounded-xl border border-white/[0.08] bg-card/60 text-left transition-colors hover:border-amber-400/40">
                <img src={mediaSrc(p.image)} alt="" className="h-full w-20 shrink-0 object-cover" />
                <div className="min-w-0 flex-1 p-2.5">
                  <span className="inline-flex items-center rounded-full bg-amber-400 px-1.5 py-px text-[10px] font-bold text-black">#{n}</span>
                  <p className="mt-1 truncate text-sm font-semibold text-white">{p.title}</p>
                  <p className="truncate text-xs text-muted-foreground">{priceLabel(p)}{p.district ? ` · ${p.district}` : ""}</p>
                </div>
                <span role="button" tabIndex={-1} data-testid={`top-unrank-${n}`} title="Remove from top 5" onClick={(e) => unrank(e, p)}
                  className="absolute right-1.5 top-1.5 grid h-6 w-6 place-items-center rounded-full bg-black/60 text-white opacity-0 transition-opacity hover:bg-brand-red group-hover:opacity-100"><X className="h-3 w-3" /></span>
              </button>
            );
          })}
        </div>
      )}
    </section>
  );
};
